import React from 'react';
import { BsInstagram } from 'react-icons/bs';
import { FaLinkedinIn } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <a href='https://www.linkedin.com/in/lucija-seljan/' target='_blank'>
        <div>
            <FaLinkedinIn />
        </div>
      </a>

      <a href='https://www.instagram.com/lucijaseljan/' target='_blank'>
        <div>
            <BsInstagram />
        </div>
      </a>
    </div>
  )
}

export default SocialMedia;